import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const baseTextInput = basic.input({
    id: "basic-input-text",
    label: "Text",
    description: "This is a basic text input, use it to add text to your page.",
    content: withUniqueClass("txt", (cls) => `<p class="${cls}">Write your text here...</p>`),
});
